import { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import './AutoCadastroUsuario.css';

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const OrgaoUsuarioSiape =

withRouter(

// redux
connect(
	(null), 
	(mapDispatchToProps)
)(

	class extends Component {

		render() {
			const solicitacao = this.props.solicitacao;
			return(
				<Fragment>
					<div className="row">
						<div className="col-md">
							<div className="field">
								<div className="input">
									<label>Órgão:</label>
									<input value={solicitacao.orgaoExercicioUsuario} disabled/>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="field">
								<div className="input">
									<label>Uorg de Exercício:</label>
									<input value={solicitacao.uorgExercicioUsuario} disabled/>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="field">
								<div className="input">
									<label>Uorg de Lotação:</label>
									<input value={solicitacao.uorgLotacaoUsuario} disabled/>
								</div>
							</div>
						</div>
					</div>
				</Fragment>	
			);
		}
	}

) // redux
); // router